import { ReactElement } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import {
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   TestableComponentProps,
   Tooltip,
} from '@dreryk/react-components';

type PatientDataAccessFormAccessModeFieldLabelProps = TestableComponentProps & {
   readonly tooltipContent: TranslatableText;
};

export const PatientDataAccessFormAccessModeFieldIcon = (
   props: PatientDataAccessFormAccessModeFieldLabelProps
): ReactElement => {
   return (
      <Tooltip testId={props.testId} content={props.tooltipContent}>
         <IconWrapper testId={'description'} size={IconSize.SMALL}>
            <QuestionmarkCircleIcon />
         </IconWrapper>
      </Tooltip>
   );
};
